<div class="d-flex justify-content-end">
    @if (this.hasRole('admin')) {
        <ui-dropdown>
            <ui-button
                drop-trigger
                variant="outline"
            >
                Ações
            </ui-button>

            <ui-drop-item (click)="shapeUploadComponent.showModal()">
                <i class="pi pi-upload"></i>Upload de Shapes
            </ui-drop-item>
        </ui-dropdown>
    }
</div>


<div class="d-flex w-100 flex-wrap">
        @if (someMenuEnabled()) {
                @for (menu of menus; track menu.id) {
                    <div
                        class="modulo-card"
                        [routerLink]="[menu.link]"
                    >
                        <div class="modulo-card-content">
                            <div class="modulo-card-content-icon">
                                <i class="{{menu.icon}}"></i>
                            </div>
                            <div class="modulo-card-content-title-container">
                                <div class="modulo-card-content-title">{{ menu.title }}</div>
                                <div class="modulo-card-content-desc">{{ menu.subTitle }}</div>
                            </div>
                        </div>

                        <ui-button
                            variant="outline"
                            color="primary"
                            [routerLink]="[menu.link]"
                        >
                            <i class="fa fa-arrow-right"></i>
                        </ui-button>
                    </div>
                }
        } @else {
            <div class="text-center p-4">
                <h4><strong>Não há funcionalidades disponíveis. Por favor, entre em contato com o suporte.</strong>
                </h4>
            </div>
        }
</div>

<app-upload-shapes
    #shapeUploadComponent
></app-upload-shapes>

